// src/i18n/cs.ts
var cs = {
  "common.cancel": "Zru\u0161it",
  "common.save": "Ulo\u017Eit",
  "common.delete": "Smazat",
  "common.confirm": "Potvrdit",
  "common.close": "Zav\u0159\xEDt",
  "common.loading": "Na\u010D\xEDt\xE1n\xED\u2026",
  "common.error": "N\u011Bco se pokazilo",
  "common.retry": "Zkusit znovu",
  "common.search": "Hledat",
  "common.empty": "\u017D\xE1dn\xE1 data",
  "common.required": "Povinn\xE9",
  "errorBoundary.title": "Str\xE1nku se nepoda\u0159ilo zobrazit",
  "errorBoundary.subtitle": "omlouv\xE1me se za komplikace",
  "errorBoundary.alertTitle": "N\u011Bco se pokazilo",
  "errorBoundary.alertBody": "Str\xE1nku m\u016F\u017Eete zkusit znovu na\u010D\xEDst. Pokud se probl\xE9m bude opakovat, dejte n\xE1m pros\xEDm v\u011Bd\u011Bt.",
  "errorBoundary.actionHome": "P\u0159ej\xEDt na \xFAvod",
  "errorBoundary.actionReload": "Zkusit znovu",
  "pagination.prev": "P\u0159edchoz\xED",
  "pagination.next": "Dal\u0161\xED",
  "pagination.perPage": "na str\xE1nku",
  "pagination.perPageAria": "Po\u010Det z\xE1znam\u016F na str\xE1nku",
  "pagination.nounOne": "z\xE1znam",
  "pagination.nounFew": "z\xE1znamy",
  "pagination.nounMany": "z\xE1znam\u016F",
  "pagination.summary": "{count} {noun} \xB7 strana {page}",
  "pagination.summaryWithTotal": "{count} {noun} \xB7 strana {page} z {totalPages}",
  "pagination.range": "Zobrazeno {start}\u2013{end} z {total}",
  "pagination.rangeWithNoun": "Zobrazeno {start}\u2013{end} z {total} {noun}",
  "apiError.401": "P\u0159ihl\xE1\u0161en\xED vypr\u0161elo. P\u0159ihlaste se znovu.",
  "apiError.403": "Nem\xE1te opr\xE1vn\u011Bn\xED k t\xE9to akci.",
  "apiError.404": "Z\xE1znam nebyl nalezen.",
  "apiError.server": "Chyba serveru. Zkuste to znovu.",
  "apiError.generic": "Chyba {status}.",
  "apiError.unexpected": "Neo\u010Dek\xE1van\xE1 chyba.",
  "sidebar.navAria": "Hlavn\xED navigace",
  "sidebar.profileAria": "M\u016Fj profil",
  "sidebar.logout": "Odhl\xE1sit se",
  "sidebar.logoutAria": "Odhl\xE1sit se z aplikace",
  "topbar.menuOpenAria": "Otev\u0159\xEDt menu",
  "field.boolean.true": "Ano",
  "field.boolean.false": "Ne",
  "picker.date.placeholder": "DD.MM.RRRR",
  "picker.date.dialogLabel": "V\xFDb\u011Br data",
  "picker.date.clearLabel": "Vymazat datum",
  "picker.date.openLabel": "Otev\u0159\xEDt kalend\xE1\u0159",
  "picker.date.invalidFormat": "Neplatn\xFD form\xE1t data (DD.MM.RRRR)",
  "picker.week.placeholder": "Vyberte t\xFDden",
  "picker.week.dialogLabel": "V\xFDb\u011Br t\xFDdne",
  "picker.week.clearLabel": "Vymazat t\xFDden",
  "picker.month.placeholder": "Vyberte m\u011Bs\xEDc",
  "picker.month.dialogLabel": "V\xFDb\u011Br m\u011Bs\xEDce",
  "picker.month.clearLabel": "Vymazat m\u011Bs\xEDc",
  "picker.range.placeholder": "Vyberte obdob\xED",
  "picker.range.dialogLabel": "V\xFDb\u011Br obdob\xED",
  "picker.range.clearLabel": "Vymazat obdob\xED",
  "picker.time.placeholder": "HH:MM",
  "picker.time.dialogLabel": "V\xFDb\u011Br \u010Dasu",
  "picker.time.clearLabel": "Vymazat \u010Das",
  "picker.time.openLabel": "Otev\u0159\xEDt v\xFDb\u011Br \u010Dasu",
  "picker.time.invalidFormat": "Neplatn\xFD form\xE1t \u010Dasu (HH:MM)",
  "picker.time.hours": "Hodina",
  "picker.time.minutes": "Minuta",
  "picker.datetime.placeholder": "DD.MM.RRRR HH:MM",
  "picker.datetime.dialogLabel": "V\xFDb\u011Br data a \u010Dasu",
  "picker.datetime.clearLabel": "Vymazat datum a \u010Das",
  "picker.datetime.openLabel": "Otev\u0159\xEDt v\xFDb\u011Br data a \u010Dasu"
};
var cs_default = cs;

export { cs_default as default };
//# sourceMappingURL=cs.js.map
//# sourceMappingURL=cs.js.map